import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Image,
  Button,
  Grid,
  GridRow,
  GridColumn,
  Container,
  Dropdown,
  Icon,
  Input,
  Label,
  Table,
} from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import cx from "classnames";
import dateFormat from "dateformat";

import { updateAccount } from "actions/accounts";
import uploadIcon from "../../../../../images/upload.svg";
import exclamatory from '../../../../../images/exclamatory.svg';
import deleteIcon from '../../../../../images/delete.svg'
import styles from "./basicdetails.module.scss";
import ConfirmModal from "components/ui/ConfirmModal";
import _ from "lodash";

import industryOptions from 'data/industries.json';
import countryOptions from 'data/countries.json';
import continentOptions from 'data/continents.json';

import { getOrderForms, deleteOrderForm, invalidateOrderForms } from "actions/accounts";

import UploadOrderForm from "./orderFormPopup";
import AuthService from "services/auth.service";
import { useParams} from "react-router-dom";
import SaveChanges from "components/ui/Buttons/SaveButton";

const initData = {
  name: null,
  url: null,
  industry: null,
  segment: null,
  employees: null,
  country: null,
  continent: null,
  potentialUsers: null,
  projectSponsorName: null,
  projectSponsorEmail: null,
  projectSponsorDesignation: null,
  projectSponsorContact: null
}

export default function BasicDetails({ disabled, account }) {
  const dispatch = useDispatch();

  const updatingAccount = useSelector((state) => state.accounts.updateAccount);

  const [open, setOpen] = useState(false);
  const [initialRender, setInitialRender] = useState(true);

  const [date, setDate] = useState("");
  const [disableSave, setDisableSave] = useState(true);
  

  const [error, setError] = useState("");
  const [orderForms, setOrderForms] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedOrderForm, setSelectedOrderForm] = useState();
  const [showUploadOrderForm, setShowUploadOrderForm] = useState(false)
  const uploadedOrderForms = useSelector((state) => _.get(state, "accounts.orderForms", []))
  const updatingOrderForm = useSelector((state) => state.accounts.updatingOrderForm);

  const [initialTableRender, setInitialTableRender] = useState(true)
  const deletingOrderForm = useSelector((state) => state.accounts.deletingOrderForm);

  const [accountObj, setAccountObj] = useState(initData);
  const [initAccountObj, setInitAccountObj] = useState(initData);
  const params = useParams();

  useEffect(() => {
    onSetAccountObj();
    setInitialRender(false);

    if (!_.isEmpty(account)) {
      dispatch(getOrderForms({ id: account.id }));
    }

  }, [account]);

  useEffect(() => {
    if (_.isEqual(initAccountObj, accountObj)) {
      setDisableSave(true);
    }
    else {
      setDisableSave(false);
    }
  }, [accountObj])

  const onSetAccountObj = () => {
    if (!_.isEmpty(account)) {

      let data = {
        name: account.name,
        url: account.url,
        industry: account.industry,
        segment: account.segment,
        employees: account.employees,
        country: account.country,
        continent: account.continent,
        potentialUsers: account.potentialUsers,
        projectSponsorName: account.projectSponsorName,
        projectSponsorEmail: account.projectSponsorEmail,
        projectSponsorDesignation: account.projectSponsorDesignation,
        projectSponsorContact: account.projectSponsorContact
      };

      setAccountObj(data);
      setInitAccountObj(data);

    }
  }

  useEffect(() => {
    if (!initialRender && updatingAccount && !updatingAccount.updating) {
      if (updatingAccount.success) {
        toast.success(`Successfully updated ${account.name}`);
      } else {
        toast.error(`failed to update ${account.name}`);
      }
    }
  }, [updatingAccount]);

  useEffect(() => {
    if (!initialRender && updatingOrderForm && !updatingOrderForm.updating) {
      if (updatingOrderForm.success) {
        toast.success(`Successfully uploaded order form for ${account.name}`);
        dispatch(getOrderForms({ id: account.id }))
      } else {
        toast.error(`failed to update ${account.name}`);
      }
    }
  }, [updatingOrderForm]);

  useEffect(() => {
    if (!initialRender && deletingOrderForm && !deletingOrderForm.deleting) {
      if (deletingOrderForm.success) {
        toast.success(`Successfully deleted order form for ${account.name}`);
        dispatch(getOrderForms({ id: account.id }))
      } else {
        toast.error(`failed to delete orderform`);
      }
    }
  }, [deletingOrderForm]);

  const validateEmail = (email) => {
    const mailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.match(mailFormat)) {
      return true;
    }
    return false;
  };

  const onSaveChanges = (e) => {
    const email = accountObj.projectSponsorEmail;

    if (_.size(email) > 0 && !validateEmail(email)) {
      setError("Please enter a valid email");
      setDisableSave(true);
      return;
    }

    setError("");
    setDisableSave(false);
    setOpen(true);
  };

  const onCancelChanges = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  const onCancelDelete = (e) => {
    e.preventDefault();
    setDate();

    setShowDeleteConfirm(false);
  }

  const onReset = (e) => {
    e.preventDefault();

    setAccountObj({ ...account });
    setOpen(false);
  };

  const onAccountChangeConfirm = (e) => {
    e.preventDefault();

    dispatch(updateAccount({ id: account.id, data: accountObj }));

    setOpen(false);
  };

  useEffect(() => {
    if (!initialTableRender) {
      var component = document.querySelector('.myComponent')
      component.scrollTop = component.scrollHeight;
    }
  }, [uploadedOrderForms])

  useEffect(() => {

    return () => {
      dispatch(invalidateOrderForms())
    }

  }, [])

  const employeeRangeOptions = [
    { key: 1, text: "0-50", value: "0-50" },
    { key: 2, text: "50-100", value: "50-100" },
    { key: 3, text: "100-250", value: "100-250" },
    { key: 4, text: "250-500", value: "250-500" },
    { key: 5, text: "500-1000", value: "500-1000" },
    { key: 6, text: "1000-10000", value: "1000-10000" },
    { key: 7, text: "More than 10000", value: "More than 10000" },
  ];


  const handleAccountUpdate = (key, value) => {

    if (key === "country") {

      const index = _.findIndex(countryOptions, { value: value });
      const continent = continentOptions[index].value;

      setAccountObj({ ...accountObj, country: value, continent: continent });

    } else if (key === "continent") {

      const index = _.findIndex(continentOptions, { value: value });
      const country = countryOptions[index].value;

      setAccountObj({ ...accountObj, continent: value, country: country });

    } else if (key === "potentialUsers") {

      setAccountObj({ ...accountObj, [key]: value < 0 ? 0 : value });

    } else {
      setAccountObj({ ...accountObj, [key]: value });
    }
  }

  const handleUploadClose = () => {
    setShowUploadOrderForm(false);
  }

  const handleDeleteOrderForm = (id) => {
    setShowDeleteConfirm(true);
    setSelectedOrderForm(id);
  }

  const handleDeleteConfirm = () => {
    setShowDeleteConfirm(false)
    dispatch(deleteOrderForm({ id: account.id, orderFormId: selectedOrderForm }))
  }

  const handleOrderFormSave = () => {
    setShowUploadOrderForm(false);
  }

  const handleDownload = (id) => {
    const url = AuthService.getURL(`api/1.0/assets/${id}/download`);

    window.open(url, '_blank');
  }

  const handleInputKeyDown = (event) => {
    if (event.key === "Enter" || event.keyCode == 13) {
      event.preventDefault();
      setShowUploadOrderForm(false);
    }
  };
 
  return (
    <>
      <Container className={cx(styles.container)}>
        <Form className={cx(styles.form, "myComponent")}>
          <Grid>

            <Grid.Row>
              <Grid.Column>
                <span className={cx(styles.title)}> Basic Details </span>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                <Container className={cx(styles.upload)}>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        {account && account.logo ? (
                          <>
                            <Image
                              className={cx(styles.image, styles.iconContainer)}
                              src={account.logo ? account.logo.thumbnail : ""}
                            />
                          </>
                        ) : (
                          <>
                            <div className={cx(styles.box, styles.iconContainer)}>
                              <Icon
                                name="images outline"
                                className={cx(styles.boxIcon)}
                              />
                            </div>
                          </>
                        )}
                        {/* <div className={styles.uploadNewVersion}>
                          <p className={styles.uploadContainer}>UPLOAD ICON</p>
                          <input type="file" accept="image/*"
                            // onChange={this._handleUploadNewVersion}
                          ></input>
                        </div> */}
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Container>
              </Grid.Column>
              <Grid.Column width={12}>
                <Container>
                  <Grid>
                    <Grid.Row className={styles.detailsRow}>
                      <Grid.Column>
                        <Label className={styles.labelStyle}> Name </Label>
                        <Form.Field>
                          <Input
                            value={accountObj?.name}
                            onKeyDown={handleInputKeyDown}
                            onChange={(e, { value }) => handleAccountUpdate("name", value)}
                            className={cx(styles.inputbox)}
                            disabled={disabled}
                          />
                        </Form.Field>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className={styles.detailsRow}>
                      <Grid.Column>
                        <Label className={styles.labelStyle}> URL </Label>
                        <Form.Field>
                          <Input
                            value={accountObj?.url}
                            onKeyDown={handleInputKeyDown}
                            onChange={(e, { value }) => handleAccountUpdate("url", value)}
                            className={cx(styles.inputbox)}
                            disabled={disabled}
                          />
                        </Form.Field>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Container>
              </Grid.Column>
            </Grid.Row>

          </Grid>

          <Grid>
            <GridRow columns={2}>
              <GridColumn>
                <Form.Field>
                  <label>Industry</label>
                  <Dropdown
                    value={accountObj?.industry}
                    className={cx(styles.inputbox)}
                    placeholder="select a industry"
                    options={industryOptions}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("industry", value)}
                    disabled={disabled}
                    selection
                  />
                </Form.Field>
              </GridColumn>

              <GridColumn>
                <Form.Field>
                  <label>Employees</label>
                  <Dropdown
                    value={accountObj?.employees}
                    className={cx(styles.inputbox)}
                    placeholder="select employees"
                    options={employeeRangeOptions}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("employees", value)}
                    selection
                  />
                </Form.Field>
              </GridColumn>
            </GridRow>

            <GridRow columns={2}>
              <GridColumn>
                <Form.Field>
                  <label>Potential Users</label>
                  <Input
                    value={accountObj?.potentialUsers}
                    placeholder={!accountObj?.potentialUsers && "0"}
                    type="number"
                    className={cx(styles.inputbox)}
                    min={0}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("potentialUsers", value)}
                  />
                </Form.Field>
              </GridColumn>
              <GridColumn>
                <Form.Field>
                  <label>Segment</label>
                  <Input
                    value={accountObj?.segment}
                    placeholder="Marketing"
                    className={cx(styles.inputbox)}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("segment", value)}
                  />
                </Form.Field>
              </GridColumn>
            </GridRow>

            <GridRow columns={2}>
              <GridColumn>
                <Form.Field>
                  <label>Country</label>
                  <Dropdown
                    value={accountObj?.country}
                    placeholder="select a country"
                    className={cx(styles.inputbox, styles.regionDropDown)}
                    options={countryOptions}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("country", value)}
                    selection
                  />
                </Form.Field>
              </GridColumn>
              <GridColumn>
                <Form.Field>
                  <label>Continent</label>
                  <Dropdown
                    disabled
                    value={accountObj?.continent}
                    className={cx(styles.inputbox)}
                    placeholder="select a continent"
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("continent", value)}
                    options={continentOptions}
                    selection
                  />
                </Form.Field>
              </GridColumn>
            </GridRow>

            <Form.Field className={cx(styles.fields, styles.projectSponsorTitle)}>
              <label>Project Sponsor</label>
            </Form.Field>

            <GridRow columns={2} className={cx(styles.projectSponsorContent)}>
              <GridColumn>
                <Form.Field>
                  <Input
                    value={accountObj?.projectSponsorName}
                    placeholder="Name" className={cx(styles.inputbox)}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("projectSponsorName", value)}
                  />
                </Form.Field>
              </GridColumn>
              <GridColumn>
                <Form.Field>
                  <Input placeholder="Email" type="email" className={cx(styles.inputbox)}
                    value={accountObj?.projectSponsorEmail}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("projectSponsorEmail", value)}
                  />
                </Form.Field>
              </GridColumn>
              <GridColumn>
                <Form.Field>
                  <Input
                    placeholder="Designation"
                    value={accountObj?.projectSponsorDesignation}
                    className={cx(styles.inputbox, styles.projectSponsorRowTwo)}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("projectSponsorDesignation", value)}
                  />
                </Form.Field>
              </GridColumn>
              <GridColumn>
                <Form.Field>
                  <Input placeholder="Contact" className={cx(styles.inputbox, styles.projectSponsorRowTwo)}
                    value={accountObj?.projectSponsorContact}
                    onKeyDown={handleInputKeyDown}
                    onChange={(e, { value }) => handleAccountUpdate("projectSponsorContact", value)}
                  />
                </Form.Field>
              </GridColumn>
            </GridRow>
            <GridRow columns={2}>
              <GridColumn>
                <Form.Field className={cx(styles.fields, styles.orderFormSignedDate)}>
                  <label className={styles.dateTitle}>Order Form Signed Date
                    <Button onClick={() => setShowUploadOrderForm(true)} className={styles.uploadiconbutton}>
                      <img src={uploadIcon} height="14px" width="14px"
                        alt="cannot upload" className={styles.uploadicon} />
                    </Button>
                  </label>

                </Form.Field>
              </GridColumn>
            </GridRow>
            {_.size(uploadedOrderForms) > 0 && <GridRow columns={2} className={styles.tableContainer}>

              <span className={styles.header}> *uploaded order forms</span>
              <Table celled className={styles.table}>
                <Table.Header>
                  <Table.Row>
                    <Table.Cell width={2} className={cx(styles.header)}>
                      SNO
                    </Table.Cell>
                    <Table.Cell width={4} className={cx(styles.header)}>
                      Order Form signed date
                    </Table.Cell>
                    <Table.Cell width={2} className={cx(styles.header, styles.deleteCell)}>

                    </Table.Cell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {uploadedOrderForms?.map((form, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{index + 1}</Table.Cell>
                      <Table.Cell>
                        <button className={styles.buttonContainer} onClick={() => handleDownload(form.assetId)}>
                          {dateFormat(form.orderFormDate, 'yyyy-mm-dd')}
                        </button>
                      </Table.Cell>
                      <Table.Cell className={styles.deleteCell}>
                        <img src={deleteIcon} onClick={() => handleDeleteOrderForm(form.id)} className={styles.deleteContainer} name="trash" />
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </GridRow>}
          </Grid>
        </Form>
        <div className={cx(styles.buttonstyles)}>
          {error && <span className={styles.errorMessage}>
            <img src={exclamatory} height="14px" width="14px"
              alt="error" className={styles.errorIcon} />
            {error}</span>}
          <SaveChanges onClick={onSaveChanges} disabled={disableSave} />
          <Button className={cx(styles.cancelbutton)} onClick={onReset}>Reset</Button>
        </div>

        <ConfirmModal
          open={open}
          setOpen={setOpen}
          onSave={onAccountChangeConfirm}
          onCancel={onCancelChanges}
          content={`Are you sure want to update ${account ? account.name : ""
            }?`}
        />

        <UploadOrderForm
          open={showUploadOrderForm}
          setOpen={setShowUploadOrderForm}
          onCancel={handleUploadClose}
          orderForms={orderForms}
          onSave={handleOrderFormSave}
          setOrderForms={setOrderForms}
          setInitialTableRender={setInitialTableRender}
          account={account}
        />

        <ConfirmModal
          open={showDeleteConfirm}
          setOpen={setShowDeleteConfirm}
          onSave={handleDeleteConfirm}
          onCancel={onCancelDelete}
          content={`Are you sure want to delete the order form
            ?`}
        />
      </Container>
    </>
  );
}
